export default __webpack_public_path__ + "static/1-ed333cf9ab1362606203103a8b3524c6.svg";